import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Printer, ArrowLeft } from "@phosphor-icons/react";

function formatDate(d) {
  if (!d) return "—";
  try { return new Date(d).toLocaleDateString("pt-BR"); } catch { return d; }
}

export default function OrdemImprimir() {
  const { id } = useParams();
  const nav = useNavigate();
  const [os, setOs] = useState(null);
  const [equipes, setEquipes] = useState([]);
  const [contratos, setContratos] = useState([]);
  const [empresas, setEmpresas] = useState([]);

  useEffect(() => {
    (async () => {
      const [{ data: osData }, { data: eqs }, { data: cts }, empRes] = await Promise.all([
        api.get(`/ordens/${id}`), api.get("/equipes"), api.get("/contratos"),
        api.get("/empresas").catch(() => ({ data: [] })),
      ]);
      setOs(osData);
      setEquipes(eqs);
      setContratos(cts);
      setEmpresas(empRes.data || []);
    })();
  }, [id]);

  if (!os) return <div style={{ padding: 32 }}>Carregando…</div>;

  const equipe = equipes.find((e) => e.id === os.equipe_id);
  const contrato = contratos.find((c) => c.id === os.contrato_id);
  const empresa = empresas.find((e) => e.id === os.empresa_executora_id);

  return (
    <div className="print-root" translate="no" lang="pt-BR" data-notranslate>
      <style>{`
        @media screen {
          .print-root { max-width: 900px; margin: 24px auto; padding: 24px; background: #fff; }
          .print-toolbar { display: flex; gap: 8px; margin-bottom: 20px; }
          @page { margin: 0; }
        }
        @media print {
          @page { size: A4; margin: 12mm; }
          body { background: #FFF !important; }
          .no-print { display: none !important; }
          .print-root { padding: 0; margin: 0; max-width: 100%; }
          .sidebar, .mobile-bottom-nav, .safety-stripes { display: none !important; }
          .app-shell { display: block !important; }
          .main-content { min-height: auto !important; }
        }
        .p-header { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 3px solid #0A0A0A; padding-bottom: 12px; margin-bottom: 20px; }
        .p-logo { display: flex; align-items: center; gap: 12px; }
        .p-logo-box { width: 44px; height: 44px; background: #FFCC00; display: flex; align-items: center; justify-content: center; font-weight: 900; font-family: 'Chivo', sans-serif; font-size: 1rem; }
        .p-title { font-family: 'Chivo', sans-serif; font-weight: 900; font-size: 1.75rem; letter-spacing: -0.02em; text-transform: uppercase; margin: 0; line-height: 1; }
        .p-sub { font-size: 0.72rem; color: #52525B; text-transform: uppercase; letter-spacing: 0.15em; margin-top: 4px; }
        .p-badge { display: inline-block; padding: 4px 10px; background: #0A0A0A; color: #FFF; font-family: 'IBM Plex Mono', monospace; font-weight: 700; font-size: 1rem; }
        .p-status { display: inline-block; padding: 3px 12px; background: #FFCC00; color: #0A0A0A; font-weight: 700; font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.1em; }
        .p-section { margin-bottom: 20px; page-break-inside: avoid; }
        .p-section-title { font-family: 'Chivo', sans-serif; font-weight: 800; font-size: 0.85rem; text-transform: uppercase; letter-spacing: 0.18em; padding: 6px 10px; background: #F4F4F5; border-left: 4px solid #FFCC00; margin-bottom: 10px; }
        .p-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px 20px; margin-bottom: 12px; }
        .p-field { padding: 6px 0; border-bottom: 1px dotted #D4D4D8; font-size: 0.85rem; }
        .p-field-label { font-size: 0.65rem; text-transform: uppercase; letter-spacing: 0.12em; color: #71717A; font-weight: 700; margin-bottom: 2px; }
        .p-field-value { font-weight: 600; color: #0A0A0A; }
        table.p-tbl { width: 100%; border-collapse: collapse; font-size: 0.8rem; }
        table.p-tbl th { background: #0A0A0A; color: #FFF; padding: 6px 8px; text-align: left; font-size: 0.68rem; text-transform: uppercase; letter-spacing: 0.1em; font-weight: 700; }
        table.p-tbl td { padding: 6px 8px; border-bottom: 1px solid #E4E4E7; vertical-align: top; }
        .p-signatures { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; margin-top: 60px; page-break-inside: avoid; }
        .p-sign { text-align: center; padding-top: 40px; border-top: 1px solid #0A0A0A; font-size: 0.8rem; }
        .p-footer { margin-top: 24px; padding-top: 12px; border-top: 1px solid #E4E4E7; font-size: 0.7rem; color: #71717A; text-align: center; }
      `}</style>

      <div className="print-toolbar no-print">
        <button className="btn btn-outline" onClick={() => nav(`/ordens/${id}`)}>
          <ArrowLeft size={16} weight="bold" /> Voltar
        </button>
        <button className="btn btn-primary" onClick={() => window.print()} data-testid="btn-imprimir">
          <Printer size={16} weight="bold" /> Imprimir / Salvar PDF
        </button>
      </div>

      {/* Cabeçalho */}
      <div className="p-header">
        <div className="p-logo">
          <div className="p-logo-box">OS</div>
          <div>
            <h1 className="p-title" translate="no">Ordem de Serviço</h1>
            <div className="p-sub" translate="no">OS TECNOVIAS · Sinalização Viária</div>
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div className="p-badge">Nº {os.numero}</div>
          <div style={{ marginTop: 8 }}><span className="p-status">{os.status}</span></div>
          <div style={{ fontSize: "0.72rem", color: "#71717A", marginTop: 6 }}>
            Emitida em <strong>{formatDate(os.data_emissao)}</strong>
          </div>
        </div>
      </div>

      {/* Empresa Executora */}
      {empresa && (
        <div className="p-section" translate="no">
          <div className="p-section-title">Empresa Executora</div>
          <div className="p-grid">
            <div className="p-field">
              <div className="p-field-label">Razão Social</div>
              <div className="p-field-value">{empresa.razao_social || empresa.nome || "—"}</div>
            </div>
            <div className="p-field">
              <div className="p-field-label">CNPJ</div>
              <div className="p-field-value">{empresa.cnpj || "—"}</div>
            </div>
            <div className="p-field">
              <div className="p-field-label">Endereço</div>
              <div className="p-field-value">{[empresa.endereco, empresa.cidade, empresa.uf].filter(Boolean).join(", ") || "—"}</div>
            </div>
            <div className="p-field">
              <div className="p-field-label">Contato</div>
              <div className="p-field-value">{[empresa.telefone, empresa.email].filter(Boolean).join(" · ") || "—"}</div>
            </div>
          </div>
        </div>
      )}

      {/* Dados gerais */}
      <div className="p-section">
        <div className="p-section-title">Dados da Obra</div>
        <div className="p-grid">
          <div className="p-field">
            <div className="p-field-label">Contratante</div>
            <div className="p-field-value">{os.contratante || "—"}</div>
          </div>
          <div className="p-field">
            <div className="p-field-label">Contrato</div>
            <div className="p-field-value">{contrato ? `${contrato.numero} · ${contrato.tipo}` : os.tipo_contrato || "—"}</div>
          </div>
          <div className="p-field">
            <div className="p-field-label">Rodovia</div>
            <div className="p-field-value">{os.rodovia || "—"}</div>
          </div>
          <div className="p-field">
            <div className="p-field-label">Trecho</div>
            <div className="p-field-value">{os.trecho || "—"}</div>
          </div>
          <div className="p-field">
            <div className="p-field-label">Município / UF</div>
            <div className="p-field-value">{os.municipio || "—"}</div>
          </div>
          <div className="p-field">
            <div className="p-field-label">Equipe Responsável</div>
            <div className="p-field-value">{equipe?.nome || "—"}{equipe?.supervisor ? ` (Supervisor: ${equipe.supervisor})` : ""}</div>
          </div>
          <div className="p-field">
            <div className="p-field-label">Previsão de Início</div>
            <div className="p-field-value">{formatDate(os.data_inicio_producao)}</div>
          </div>
          <div className="p-field">
            <div className="p-field-label">Previsão de Término</div>
            <div className="p-field-value">{formatDate(os.prazo_conclusao)}</div>
          </div>
        </div>
      </div>

      {/* Itens de Serviço */}
      <div className="p-section">
        <div className="p-section-title">Serviços a Executar ({os.itens?.length || 0})</div>
        {(!os.itens || os.itens.length === 0) ? (
          <div style={{ padding: 16, color: "#71717A", fontSize: "0.85rem" }}>Sem itens cadastrados.</div>
        ) : (
          <table className="p-tbl">
            <thead>
              <tr>
                <th style={{ width: 30 }}>#</th>
                <th style={{ width: 110 }}>Categoria</th>
                <th>Descrição · Material · Cor · Dimensão</th>
                <th style={{ width: 70, textAlign: "right" }}>Qtd</th>
                <th style={{ width: 50 }}>Unid.</th>
              </tr>
            </thead>
            <tbody>
              {os.itens.map((it, i) => (
                <tr key={it.id}>
                  <td>{i + 1}</td>
                  <td><strong>{it.categoria}</strong></td>
                  <td>
                    <div style={{ fontWeight: 600 }}>{it.descricao}</div>
                    <div style={{ fontSize: "0.72rem", color: "#52525B" }}>
                      {[it.material, it.cor, it.dimensao].filter(Boolean).join(" · ")}
                    </div>
                  </td>
                  <td style={{ textAlign: "right", fontFamily: "'IBM Plex Mono', monospace", fontWeight: 700 }}>
                    {it.qtd_planejada?.toLocaleString("pt-BR")}
                  </td>
                  <td>{it.unidade}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Materiais Necessários */}
      {os.materiais_necessarios && os.materiais_necessarios.length > 0 && (
        <div className="p-section">
          <div className="p-section-title">Materiais Necessários (Cálculo Automático)</div>
          <table className="p-tbl">
            <thead>
              <tr>
                <th>Insumo</th>
                <th style={{ width: 120, textAlign: "right" }}>Qtd Total Planejada</th>
                <th style={{ width: 60 }}>Unid.</th>
              </tr>
            </thead>
            <tbody>
              {os.materiais_necessarios.map((m, i) => (
                <tr key={i}>
                  <td>{m.insumo_nome}</td>
                  <td style={{ textAlign: "right", fontFamily: "'IBM Plex Mono', monospace", fontWeight: 700 }}>
                    {m.necessario_total?.toFixed(2)}
                  </td>
                  <td>{m.unidade}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Observações */}
      {os.observacoes && (
        <div className="p-section">
          <div className="p-section-title">Observações</div>
          <div style={{ padding: 10, background: "#FAFAFA", border: "1px solid #E4E4E7", fontSize: "0.85rem", lineHeight: 1.6, whiteSpace: "pre-wrap" }}>
            {os.observacoes}
          </div>
        </div>
      )}

      {/* Espaço para anotações */}
      <div className="p-section">
        <div className="p-section-title">Anotações de Campo</div>
        <div style={{ minHeight: 80, border: "1px solid #E4E4E7", padding: 8 }}>
          {[1, 2, 3, 4].map((n) => (
            <div key={n} style={{ borderBottom: "1px dotted #D4D4D8", padding: "10px 0" }}>&nbsp;</div>
          ))}
        </div>
      </div>

      {/* Assinaturas */}
      <div className="p-signatures">
        <div className="p-sign">
          <div style={{ fontWeight: 700 }}>Supervisor / Encarregado</div>
          <div style={{ fontSize: "0.7rem", color: "#71717A", marginTop: 4 }}>Data: ___/___/______</div>
        </div>
        <div className="p-sign">
          <div style={{ fontWeight: 700 }}>Fiscal do Contrato / Contratante</div>
          <div style={{ fontSize: "0.7rem", color: "#71717A", marginTop: 4 }}>Data: ___/___/______</div>
        </div>
      </div>

      {/* Rodapé */}
      <div className="p-footer">
        OS TECNOVIAS · Sistema PCP · Emitido em {new Date().toLocaleString("pt-BR")} · OS Nº {os.numero}
      </div>
    </div>
  );
}
